import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';

const INVITE_USER_MUTATION = gql`
  mutation InviteUserToProject($projectId: ID!, $email: String!) {
    inviteUserToProject(projectId: $projectId, email: $email) {
      invitation {
        id
        email
        status
        expiresAt
        projectName
        inviterName
      }
    }
  }
`;

export function useInviteUser() {
  const [inviteUserMutation, { loading, error }] = useMutation(INVITE_USER_MUTATION);

  const inviteUser = async (projectId: string, email: string) => {
    const { data } = await inviteUserMutation({
      variables: { projectId, email },
    });
    return (data as any)?.inviteUserToProject?.invitation;
  };

  return { inviteUser, loading, error };
}